export enum Shift {
	Day = 10,
	Night = 99,
}